import { createSlice } from '@reduxjs/toolkit';

import { fetchAllPublicScenario } from './asyncActions';
import { PublicScenarioState } from './types';

const initialState: PublicScenarioState = {
  allPublicScenario: [],
  isLoadingAllPublicScenario: false
};

const publicScenarioSlice = createSlice({
  name: 'publicScenario',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAllPublicScenario.pending, state => {
      state.isLoadingAllPublicScenario = true;
    });
    builder.addCase(fetchAllPublicScenario.fulfilled, (state, action) => {
      state.isLoadingAllPublicScenario = false;
      state.allPublicScenario = action.payload;
    });
    builder.addCase(fetchAllPublicScenario.rejected, state => {
      state.isLoadingAllPublicScenario = false;
    });
  }
});

export default publicScenarioSlice.reducer;
